import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const truths = [
  { icon: FiIcons.FiMessageCircle, num: '01', title: 'The Language of Action', desc: 'His silence isn\'t withdrawal — it\'s how he processes. Learn to read what he does, not just what he says.' },
  { icon: FiIcons.FiShield, num: '02', title: 'The Burden of Provision', desc: 'He carries a silent weight of responsibility. Discover how to become his safe harbor, not his added pressure.' },
  { icon: FiIcons.FiAward, num: '03', title: 'The Need for Respect', desc: 'Respect is his love language. Understanding this truth unlocks his deepest emotional openness.' },
  { icon: FiIcons.FiHeart, num: '04', title: 'Vulnerability & Strength', desc: 'He shows love through protection. Learn how to create the safety he needs to be truly vulnerable with you.' },
  { icon: FiIcons.FiTrendingUp, num: '05', title: 'His Purpose & Drive', desc: 'A man without mission is lost. See how supporting his purpose deepens his love for you exponentially.' },
  { icon: FiIcons.FiUsers, num: '06', title: 'Loyalty & Commitment', desc: 'When he chooses you, he chooses fully. Understand the profound depth of a good man\'s commitment.' },
  { icon: FiIcons.FiCompass, num: '07', title: 'Space & Connection', desc: 'He needs space not to escape you, but to return to you fully. This truth changes everything.' },
  { icon: FiIcons.FiStar, num: '08', title: 'The Art of Being Chosen', desc: 'The final truth — how to be the woman he wants to love forever, without losing yourself.' },
];

const TheTruths = () => (
  <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
    <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-accent/5 blur-[120px] rounded-full transform translate-x-1/2 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 relative z-10">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">Inside the Book</span>
        <h3 className="text-4xl md:text-5xl font-serif font-bold mt-3 mb-5">The 8 Essential Truths</h3>
        <p className="text-slate-400 text-lg">
          Each truth is a chapter. Each chapter is a revelation. Together, they form a complete map to the male heart.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {truths.map((truth, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.07 }}
            className="bg-slate-800/50 border border-slate-700/50 p-7 rounded-2xl hover:bg-slate-800 hover:border-brand-accent/30 transition-all duration-300 group"
          >
            <div className="flex items-start justify-between mb-5">
              <div className="w-11 h-11 bg-brand-accent/20 rounded-full flex items-center justify-center text-brand-accent group-hover:bg-brand-accent group-hover:text-white transition-colors">
                <SafeIcon icon={truth.icon} className="text-xl" />
              </div>
              <span className="text-slate-700 font-serif text-2xl font-bold">{truth.num}</span>
            </div>
            <h4 className="text-lg font-serif font-bold mb-2">{truth.title}</h4>
            <p className="text-slate-400 leading-relaxed text-sm">{truth.desc}</p>
          </motion.div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/chapters"
          className="inline-flex items-center gap-2 bg-brand-accent text-white px-8 py-4 rounded-full font-medium hover:bg-brand-accentHover transition-colors"
        >
          Read Chapter Details <FiArrowRight />
        </Link>
      </div>
    </div>
  </section>
);

export default TheTruths;